import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router";

import { notification } from "antd";
import { AiOutlineDownload } from "react-icons/ai";
import apiCall from "../../../components/Api";
import AntdBreadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import InputTextField from "../../../components/Common/inputTextField";
import MainconternLayout from "../../../components/Layout/MainconternLayout";
import SucessModal from "../../../components/Modal/SucessModal";

const AddSitemap = ({ edit = false }) => {
  // const { id } = useParams();
  const { id, category } = useParams();
  const [success, setSuccess] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [existingFile, setExistingFile] = useState(null);
  const navigate = useNavigate();
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    setError,
    formState: { errors },
    clearErrors,
  } = useForm();

  const handleFileChange = (event) => setSelectedFile(event.target.files[0]);

  useEffect(() => {
    if (edit) {
      getMenuData();
    }
  }, [edit]);

  useEffect(() => {
    if (selectedFile?.length && getValues()?.sitemap_folder) {
      setValue("sitemap_folder", getValues()?.sitemap_folder);
    }
  }, [selectedFile, setValue, getValues]);

  const getMenuData = async () => {
    try {
      const response = await apiCall(`sitemap/get/${id}`, "GET", {});
      setValue("sitemap_name", response.data.sitemap_name);
      setValue("total_url_sitemap", response.data.total_url_sitemap);
      setValue("sitemap_folder", response.data.sitemap_folder);

      setValue("previousUpdate", response.data.updatedAt);
      setValue("live_sitemap_url", response.data.live_sitemap_url);

      const match = response.data.live_sitemap_url.match(/[^/]+\.xml$/);

      setExistingFile(match ? match[0] : null);
    } catch (err) {
      console.error(err);
    }
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}sitemap/download/${existingFile}`,
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to download file");
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      const filename = existingFile || "downloaded_file";
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error while downloading file:", error);
      notification.error({
        message: "Download Failed",
        description: "There was an issue downloading the file.",
      });
    }
  };

  const handleSitemapSubmit = async (data) => {
    const formData = new FormData();

    // Rename selectedFile to ensure it ends with .xml
    let fileToUpload = selectedFile;
    if (selectedFile) {
      const newFileName = selectedFile?.name?.endsWith(".xml")
        ? selectedFile?.name + ".xml"
        : selectedFile?.name + ".xml";

      fileToUpload = new File([selectedFile], newFileName, {
        type: selectedFile.type,
      });
    }

    if (fileToUpload) {
      formData.append("sitemap_folder", fileToUpload);
    }

    formData.append("live_sitemap_url", data.live_sitemap_url);
    formData.append("sitemap_name", data.sitemap_name);
    formData.append("total_url_sitemap", data.total_url_sitemap);
    formData.append("sitemap_category", category);

    if (edit) {
      const formData = new FormData();
      formData.append("sitemap_folder", fileToUpload);
      formData.append("live_sitemap_url", data.live_sitemap_url);
      formData.append("sitemap_name", data.sitemap_name);
      formData.append("total_url_sitemap", data.total_url_sitemap);
      formData.append("sitemap_category", category);
      formData.append("previousUpdate", getValues()?.previousUpdate);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}sitemap/update/${id}`,
          {
            method: "put",
            body: formData,
          }
        );

        const result = await response.json();
        if (response.ok) {
          setSuccess(true);
        } else {
          console.error("Update error: ", result);
        }
      } catch (error) {
        console.error("Error during update API call:", error);
      }
    } else {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}sitemap/create`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();
      if (response.ok) {
        setSuccess(true);
      } else {
        if (result?.error && result.error.includes("duplicate key")) {
          if (result.error.includes("live_sitemap_url")) {
            setError("live_sitemap_url", {
              type: "manual",
              message: "This Live Sitemap URL already exists.",
            });
          } else if (result.error.includes("sitemap_name")) {
            setError("sitemap_name", {
              type: "manual",
              message: "This Sitemap Name already exists.",
            });
          } else {
            console.error("Duplicate key error:", result.error);
          }
        } else {
          console.error(result.message || "Something went wrong");
        }
      }
    }
  };
  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Sitemap",
        link: "/sitemap/parent-sitemap",
      },
      {
        text: "Sitemap Analysis",
        link: `/sitemap/${category}`,
      },
      {
        text: edit ? `Edit` : `Add`,
        link: "",
      },
    ],
    []
  );

  return (
    <>
      <MainconternLayout
        header={
          <AntdBreadcrumbs
            className="healthsyMasterBreadCrumbs"
            breadcrumbsList={breadcrumbsList}
          />
        }
        footer={<></>}
      >
        <div className="healtharticle-container healthsyContainer">
          <form
            className="carr-dep-form ms-5"
            onSubmit={handleSubmit(handleSitemapSubmit)}
          >
            <div className="addnew-form1-autor-detail mt-5 pb-5 d-flex">
              <div className="col-md-6">
                <InputTextField
                  labelName="Sitemap Name"
                  name="sitemap_name"
                  register={register}
                  type="text"
                  errors={errors}
                  className="mt-2 h-100"
                  placeholder="Type here"
                  errorText={"Please provide a Sitemap Name"}
                  disable={category === "parent-sitemap"}
                />
              </div>
              <div className="col-md-6">
                <InputTextField
                  labelName="Total url's in Sitemap"
                  name="total_url_sitemap"
                  register={register}
                  type="number"
                  errors={errors}
                  className="mt-2 h-100"
                  placeholder="Type here"
                  errorText={"Please provide a Sitemap Name"}
                />
              </div>
            </div>
            <div className="addnew-form1-autor-detail mt-5 d-flex">
              <div className="col-md-6">
                <label className="form-label title mb-2">Sitemap File</label>
                <div className="meta-tag-file w-75 mt-2 d-flex align-items-center">
                  <input
                    type="file"
                    className="hidden custom-file-input bg-white w-75 mt-2"
                    {...register("sitemap_folder")}
                    onChange={(event) => {
                      handleFileChange(event);

                      // Get the file that was selected
                      const file = event?.target?.files[0];

                      // If there's no file and we are in "edit" mode but there's an existing file, skip validation
                      if (edit && !file && existingFile) {
                        clearErrors("sitemap_folder");
                        return;
                      }

                      // If no file is selected and we are not in edit mode, show an error
                      if (!file) {
                        setError("sitemap_folder", {
                          type: "manual",
                          message: "Please select a sitemap file",
                        });
                        return;
                      }

                      // Validate the file type (only XML files are allowed)
                      const isValidType =
                        file?.type === "application/xml" ||
                        file?.name?.endsWith(".xml");

                      if (!isValidType) {
                        setError("sitemap_folder", {
                          type: "manual",
                          message: "Please select an XML file",
                        });
                      } else {
                        // If valid, clear any existing errors
                        clearErrors("sitemap_folder");
                      }
                    }}
                    disabled={category === "parent-sitemap"}
                  />
                  <label>
                    {selectedFile
                      ? selectedFile.name
                      : existingFile
                        ? existingFile
                        : "No file chosen"}
                  </label>
                  {edit && (
                    <AiOutlineDownload
                      onClick={handleDownload}
                      style={{
                        width: "2em",
                        cursor: "pointer",
                        color: "green",
                      }}
                    />
                  )}
                </div>
                {errors.sitemap_folder && (
                  <p className="text-danger mt-1">
                    {errors.sitemap_folder.message}
                  </p>
                )}
                {/* {!selectedFile && <div>No file chosen</div>}   */}
              </div>
              {/* <div className="col-md-6">
                            <label className="form-label title mb-2">Sitemap Folder (ZIP)</label>
                            <div className="meta-tag-file w-75 mt-2 d-flex align-items-center">
                                <input
                                    type="file"
                                    className="hidden custom-file-input bg-white w-75 mt-2"
                                    accept=".zip"
                                    {...register("siteMap_zip_file", { required: true })}
                                    onChange={handleZipFileChange}
                                />
                                <label>{selectedFileZip ? selectedFileZip.name : "No file chosen"}</label>
                            </div>
                        </div> */}
              <div className="col-md-6">
                <InputTextField
                  labelName="Live Sitemap URL"
                  name="live_sitemap_url"
                  register={register}
                  errors={errors}
                  className="mt-2 h-75"
                  placeholder="Type here"
                  disable={category === "parent-sitemap"}
                  {...register("live_sitemap_url", {
                    required: "Please provide a Live Sitemap URL",
                    pattern: {
                      value: /^\/.*\.xml$/, // starts with / and ends with .xml
                      message: "URL must start with '/' and end with '.xml'",
                    },
                  })}
                />
                {errors.live_sitemap_url && (
                  <p className="text-danger mt-1">
                    {errors?.live_sitemap_url.message}
                  </p>
                )}
              </div>
            </div>
            <div className="car-dep-form-button mb-5 mt-5 pb-5">
              <button type="submit">SUBMIT</button>
            </div>
          </form>
        </div>
      </MainconternLayout>

      {success && (
        <SucessModal
          page={`/sitemap/${category}`}
          name="Sitemap"
          post="posted"
          onClick={() => navigate(`/sitemap/${category}`)}
        />
      )}
    </>
  );
};

export default AddSitemap;
